import { render, staticRenderFns } from "./InputSigarusFile.vue?vue&type=template&id=551d71d6"
import script from "./InputSigarusFile.vue?vue&type=script&lang=js"
export * from "./InputSigarusFile.vue?vue&type=script&lang=js"
import style0 from "./InputSigarusFile.vue?vue&type=style&index=0&id=551d71d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports